module.exports = __webpack_public_path__ + "static/rooms01-b5caaa33f0c46a7e434c129a598220e6.jpg";